import React from 'react';
import AlarmTierTooltip from './AlarmTierTooltip';

/**
 * Renderiza el bloque AlarmTierCard de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function AlarmTierCard({
  v
}) {
  return React.createElement("section", {
    style: {
      "order": -1,
      "position": "relative",
      "zIndex": "40",
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "backdropFilter": "blur(0.555556vh)",
      "padding": "1.111111vh 1.296296vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.740741vh",
      "flex": "none"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "alignItems": "baseline"
    }
  }, React.createElement("h2", {
    style: {
      "margin": "0",
      "fontSize": "1.296296vh",
      "fontWeight": "600"
    }
  }, v.text("Alarmas por tasa · " + (v.tierScope || 'centro'))), React.createElement("span", {
    style: {
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "color": "#8793a6"
    }
  }, v.text(v.tierTotal + " total"))), v.text("\n        "), React.createElement("div", {
    "onMouseLeave": v.tierLeave,
    style: {
      "position": "relative",
      "display": "grid",
      "gridTemplateColumns": "repeat(3,minmax(0,1fr))",
      "gap": "0.740741vh"
    }
  }, v.text("\n          "), (v.tierSegs || []).map((t, index10) => React.createElement(React.Fragment, {
    key: index10
  }, v.text("\n            "), React.createElement("div", {
    "onMouseEnter": t.enter,
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.37037vh",
      "padding": "0.555556vh 0.740741vh",
      "borderRadius": "0.555556vh",
      "border": "0.092593vh solid " + t.hbd,
      "background": t.hbg,
      "cursor": "default"
    }
  }, v.text("\n              "), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "fontSize": "1.111111vh",
      "color": "#8793a6",
      "whiteSpace": "nowrap",
      "minWidth": "0"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.416667vw",
      "height": "0.740741vh",
      "borderRadius": "0.185185vh",
      "background": t.color,
      "flex": "none"
    }
  }, null), v.text(t.label)), v.text("\n              "), React.createElement("div", {
    style: {
      "font": "500 1.851852vh 'IBM Plex Mono',monospace"
    }
  }, v.text(t.n)), v.text("\n            ")), v.text("\n          "))), v.text("\n          "), React.createElement(AlarmTierTooltip, {
    v
  }), v.text("\n        ")), v.text("\n      "));
}
